export function isLeftButton(event: MouseEvent | TouchEvent) {
  if (event.type === 'touchstart') {
    return true;
  }
  return (event.type === 'mousedown' && (event as MouseEvent).button === 0);
}

export function getEvent(event: MouseEvent | TouchEvent): MouseEvent | Touch {
  if (event.type === 'touchend' || event.type === 'touchcancel') {
    return (event as TouchEvent).changedTouches[0];
  }
  return event.type.startsWith('touch') ? (event as TouchEvent).targetTouches[0] : event as MouseEvent;
}

export function maxZIndex(selectors: string = 'body *') {
  return Array.from(document.querySelectorAll(selectors))
    .map(a => parseFloat(window.getComputedStyle(a).zIndex))
    .filter(a => !isNaN(a))
    .sort((a, b) => a - b)
    .pop() || 0;
}

export async function checkForAuthyCopy() {
  return navigator.clipboard.readText()
    .then(text => {
      const regExp = new RegExp(/^[0-9]{6}$/);
      if (!regExp.test(text)) {
        return '';
      } else {
        // console.log(text)
        return text;

      }
    })
    .catch(err => {
      return '';
      console.error('Failed to read clipboard contents: ', err);
    });
}


export function findAncestor(el, selectors) {
  if (typeof el.closest === 'function') {
    return el.closest(selectors) || null;
  }
  while (el) {
    if (el.matches(selectors)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}
import { Injectable } from '@angular/core';
import { PrivateTradeOrder } from 'src/app/shared/models/privateTradeOrder';

@Injectable({
  providedIn: 'root'
})

export class SliceAmount {
  warranty: any;
  constructor() {
    if (!localStorage.getItem("createOrder")) {
      this.warranty = new PrivateTradeOrder();
      localStorage.setItem("createOrder", JSON.stringify(this.warranty));
    } else {
      this.warranty = JSON.parse(localStorage.getItem("createOrder"));
    }
  }

  // sliceValueTo8Digit(value, digit = 8) {

  //   if (value) {
  //     // console.log(value, digit, 'value, digit')
  //     value = Number(value)
  //     let arr = value.toString().split('.')
  //     if (arr[1] && arr[1].length > 8) {
  //       //this is done to avoid round off number to its nearest integer after 8 decimal places 
  //       arr[1] = arr[1].slice(0, 8);
  //     }
  //     value = arr.join('.')
  //   }
  //   return value
  // }

  // This function accept the value that is number and digit that tells
  //  how decimal places it want to round down
  //  here the value is round down to default 8 decimal places or 
  //  if we pass digit param then it round down to that digit after decimal

  sliceValueTo8Digit(value, digit = 8) {
    if (value) {
      // value = Number(value)
      // let div = 100000000
      // if (digit == 2) {
      //   div = 100
      // } else if (digit != 2 && digit != 8) {
      //   div = 1
      //   for (let i = 0; i < digit; i++) {
      //     div = div * 10
      //   }
      // }
      // value = ((value * div) / div).toFixed(digit)
      let v = value
      value = value + ''
      if (value.indexOf('e') != -1 || value.indexOf('E') != -1) {
        value = v.toFixed(digit)
        value = value + ''
      }
      let arr = value.split('.')
      if (arr[1]) {
        arr[1] = arr[1].slice(0, digit)
        arr[1] = arr[1].replace(/0+$/, '')
        if (arr[1]) {
          value = arr.join('.')
        } else {
          value = arr[0]
        }
      }
    }
    return value
  }
}

export function returnKeyAccordingToTransactionType(activity) {

  let key = ''
  if (activity.transactionType.toLowerCase() === 'buy')
    key = 'buy'
  else if (activity.transactionType.toLowerCase() === 'sell')
    key = 'sell'
  else if (activity.transactionType.toLowerCase() === 'deposit')
    key = 'deposit'
  else if (activity.transactionType.toLowerCase() === 'withdrawal')
    key = 'withdrawal'
  else if (activity.transactionType.toLowerCase() === 'referral_earning')
    key = 'referral'
  else if (activity.transactionType.toLowerCase() === 'obsipay')
    key = 'obsipay'
  else if (activity.transactionType.toLowerCase() === 'exchange')
    key = 'exchange'
  else if (activity.transactionType.toLowerCase() === 'obsicash')
    key = 'obsicash' //sdfsfsd
  else if (activity.transactionType.toLowerCase() === 'obsicash_sell')
    key = 'obsicash_sell'
  else if (activity.transactionType.toLowerCase() === 'obsicash_buy')
    key = 'obsicash_buy'
  else if (activity.transactionType.toLowerCase() === 'deposit_earning')
    key = 'deposit_earning'
  else if (activity.transactionType.toLowerCase() === 'buy_earning')
    key = 'buy_earning'
  else if (activity.transactionType.toLowerCase() === 'sell_earning')
    key = 'sell_earning'
  else if (activity.transactionType.toLowerCase() === 'exchange_earning')
    key = 'exchange_earning'
  else if (activity.transactionType.toLowerCase() === 'obsipay_earning')
    key = 'obsipay_earning'
  else if (activity.transactionType.toLowerCase() === 'withdrawal_earning')
    key = 'withdrawal_earning'
  else if (activity.transactionType.toLowerCase() === 'referral_earning_earning')
    key = 'referral_earning_earning' //sdfsfsd
  else if (activity.transactionType.toLowerCase() === 'obsicash_buy_earning')
    key = 'obsicash_buy_earning'
  else if (activity.transactionType.toLowerCase() === 'obsicash_sell_earning')
    key = 'obsicash_sell_earning'
  else if (activity.transactionType.toLowerCase() === 'obsicash_test_earning')
    key = 'obsicash_test_earning'
  else if (activity.transactionType.toLowerCase() === 'promotions')
    key = 'promotions'
  else if (activity.transactionType.toLowerCase() === 'promotions_earning')
    key = 'promotions_earning'
  return key
}

// export const globalArrForDescription: any = [
//   { title: 'private_trade.private_buy_sell.cryptocurrency', key: 'coin', value: '', type: 'coin', image: '', },
//   { title: 'private_trade.private_buy_sell.badge', key: 'currency', value: '' },
//   { title: 'private_trade.private_buy_sell.payment_method', key: 'payment_method', value: '', type: 'paymentMethod' },
//   { title: 'private_trade.private_buy_sell.price', key: 'price', value: '', type: 'row', rowText: 'private_trade.private_buy_sell.aboveMarket', rowValue: '10%', colorType: 'above' },
//   { title: 'private_trade.private_buy_sell.amount', key: 'amount', value: '' },
//   { title: 'private_trade.private_buy_sell.subTotal', key: 'subTotal', value: '' },
//   { title: 'private_trade.private_buy_sell.fee', key: 'fee', value: '' },
//   { title: 'private_trade.private_buy_sell.total', key: 'total', value: '', bold: true },
// ]

export const globalArrForDescriptionForBuy: any = [
  { title: 'private_trade.private_buy_sell.cryptocurrency', key: 'coin', value: '', type: 'coin', image: '', },
  { title: 'private_trade.private_buy_sell.badge', key: 'currency', value: '' },
  { title: 'private_trade.private_buy_sell.payment_method', key: 'payment_method', value: '', type: 'paymentMethod' },
  { title: 'private_trade.private_buy_sell.price', key: 'price', value: '', type: 'row', rowText: '', rowValue: '', colorType: '' },
  { title: 'private_trade.private_buy_sell.total', key: 'amount', value: '' },
  { title: 'private_trade.private_buy_sell.fee', key: 'fee', value: '' },
  { title: 'private_trade.private_buy_sell.totalToSend', key: 'subTotal', value: '' },
  { title: 'private_trade.private_buy_sell.totalToBuy', key: 'total', value: '' },
  { title: 'private_trade.private_buy_sell.sellerWillSpend', key: 'sellerSpend', value: '', bold: true },
]

export const globalArrForDescriptionForSell: any = [
  { title: 'private_trade.private_buy_sell.cryptocurrency', key: 'coin', value: '', type: 'coin', image: '', },
  { title: 'private_trade.private_buy_sell.badge', key: 'currency', value: '' },
  { title: 'private_trade.private_buy_sell.payment_method', key: 'payment_method', value: '', type: 'paymentMethod' },
  { title: 'private_trade.private_buy_sell.price', key: 'price', value: '', type: 'row', rowText: '', rowValue: '', colorType: '' },
  { title: 'private_trade.private_buy_sell.totalToSell', key: 'amount', value: '' },
  { title: 'private_trade.private_buy_sell.fee', key: 'fee', value: '' },
  { title: 'private_trade.private_buy_sell.totalToReceive', key: 'subTotal', value: '' },
  { title: 'private_trade.private_buy_sell.total', key: 'total', value: '' },
  { title: 'private_trade.private_buy_sell.buyerWillReceive', key: 'buyerReceive', value: '', bold: true },
]

export const globalArrForRealEstate: any = [
  { title: 'private_trade.private_buy_sell.buyer', key: 'buyer', value: '' },
  { title: 'private_trade.private_buy_sell.seller', key: 'seller', value: '' },
  { title: 'private_trade.private_buy_sell.currencyOrCrypto', key: 'coin', value: '', type: 'coin', image: '', },
  { title: 'private_trade.private_buy_sell.price', key: 'price', value: '' },
  { title: 'private_trade.private_buy_sell.fee', key: 'fee', value: '' },
  { title: 'private_trade.private_buy_sell.totalIncludingFee', key: 'total', value: '', bold: true },
]

export const globalArrForCapital: any = [
  { title: 'private_trade.private_buy_sell.transactionType', key: 'transactionType', value: '' },
  { title: 'private_trade.private_buy_sell.totalToSend', key: 'totalToSend', value: '' },
  { title: 'private_trade.private_buy_sell.warranty', key: 'warranty', value: '', },
  { title: 'private_trade.private_buy_sell.fee', key: 'fee', value: '' },
  { title: 'private_trade.private_buy_sell.totalToReceive', key: 'totalToReceive', value: '', bold: true },
]
